import { gql } from "@outschool/ui-apollo";
import { MeetingFragment } from "@outschool/ui-components-classroom";

import { ActivityFragment } from "../../shared/client/fragments/ActivityFragments";
import EnrollmentManagerCard from "../components/EnrolledClass/EnrollmentManagerCard";
import SectionManageToolbar from "../components/nav/SectionManageToolbar";
import AvailabilityFragment from "./AvailabilityFragment";
import { SectionFragment, SectionLeaderFragment } from "./SectionFragments";

export const teacherSectionsQuery = gql`
  query TeacherSections(
    $filter: String
    $excludeOrgTeachers: Boolean
    $filterByTeacher: String
    $sectionsLimit: Int
    $sectionsOffset: Int
    $activityType: CreateActivityType
  ) {
    currentUser {
      uid
      teacherAvailability {
        ...AvailabilityFragment
      }
      leaderSections: sections(
        filter: $filter
        excludeOrgTeachers: $excludeOrgTeachers
        filterByTeacher: $filterByTeacher
        limit: $sectionsLimit
        offset: $sectionsOffset
        activityType: $activityType
      ) {
        filledSpaceCount
        pausedLearnerCount
        ...SectionFragment
        ...SectionLeaderFragment
        meetings {
          ...MeetingFragment
        }
        activity {
          waitlistSeatsCount
          ...ActivityFragment
        }
        leader {
          uid
          name
          is_crosslister
        }
        enrollments(status: Enrolled) {
          uid
          learner {
            uid
            name
          }
        }
      }
    }
  }
  ${AvailabilityFragment}
  ${ActivityFragment}
  ${SectionFragment}
  ${SectionLeaderFragment}
  ${MeetingFragment}
`;
const TeacherSectionQueryLessonFragment = gql`
  fragment TeacherSectionQueryLessonFragment on Lesson {
    uid
    title
    week_number
    order_within_week
    lessonNumber
  }
`;
export const teacherSectionQuery = gql`
  query TeacherSection($uid: ID!) {
    section(uid: $uid) {
      waitlistSeatsCount
      filledSpaceCount
      validEnrollmentCount
      details {
        originalEndTime
      }
      ...SectionFragment
      ...SectionLeaderFragment
      ...SectionManageToolbar_section
      meetings {
        ...MeetingFragment
        holiday {
          name
        }
        lesson {
          ...TeacherSectionQueryLessonFragment
        }
      }
      deletedMeetings {
        ...MeetingFragment
        holiday {
          name
        }
        lesson {
          ...TeacherSectionQueryLessonFragment
        }
      }
      activity {
        uid
        meetingCount
        waitlistSeatsCount
        isClub
        leader {
          uid
          name
          ownerOfSellerOrg {
            uid
          }
        }
        ...SectionManageToolbar_activity
        ...ActivityFragment
      }
      syllabus {
        uid
        lessons {
          ...TeacherSectionQueryLessonFragment
          meetings(sectionUid: $uid) {
            uid
            start_time
            end_time
          }
        }
      }
      leader {
        uid
        name
        is_crosslister
      }
      canBeCanceled
      enrollments {
        uid
        confirmed_at
        withdrawn_at
        ongoing_start_time
        ongoing_end_time
        ...EnrollmentManagerCard_enrollment
      }
      meetingConflictInfo {
        meetingUid
        message
        conflictingSectionUid
      }
    }
  }
  ${ActivityFragment}
  ${SectionFragment}
  ${SectionLeaderFragment}
  ${SectionManageToolbar.fragments.section}
  ${SectionManageToolbar.fragments.activity}
  ${EnrollmentManagerCard.fragments.enrollment}
  ${MeetingFragment}
  ${TeacherSectionQueryLessonFragment}
`;
